import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MobileOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"mobile_off"}/>
}
